module.exports = __webpack_public_path__ + "img/index_mobile_middle_pic_6.98649d90.png";